/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { Card } from 'react-bootstrap';
import { ArrowNarrowLeftIcon } from '@heroicons/react/solid';
import { Link } from 'react-router-dom';
import { XCircleIcon } from '@heroicons/react/solid';

export interface IGoBackArrowProps {
  goBackText?: string;
  goBackLink?: string;
}

export const GoBackArrow = (props: IGoBackArrowProps) => {
  const { goBackLink, goBackText } = props;
  return (
    <p className="text-center" style={{ position: 'relative' }}>
      <Card.Link
        as={Link}
        to={goBackLink}
        className="d-flex align-items-center justify-content-center"
      >
        <ArrowNarrowLeftIcon className="icon icon-xs me-2" />
        Go Back to Home Page
      </Card.Link>
    </p>
  );
};

GoBackArrow.defaultProps = {
  goBackText: 'Back to homepage',
  goBackLink: '/',
};
